import MailchimpSubscribe from "react-mailchimp-subscribe";
import { Newsletter } from "./Newsletter";
import { useState, useEffect } from "react";

export const MailchimpForm = () => {
    const backendUrl = "https://portfolio-server-nine-zeta.vercel.app/newsletter"; // URL de l'endpoint du backend Spring Boot

    // États pour gérer le statut et le message
    const [alertStatus, setAlertStatus] = useState(null); // success ou error
    const [alertMessage, setAlertMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false); // Ajouter un état pour vérifier si l'alerte a été affichée

    const handleSubmit = async (formData) => {
        // Afficher immédiatement le message de remerciement
        setAlertStatus("success");
        setAlertMessage("Thank you for subscribing! 🎉");
        setIsSubmitted(true); // Marquer que le formulaire a été soumis

        // Envoyer la requête en arrière-plan après avoir affiché le message
        try {
            const response = await fetch(backendUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email: formData.EMAIL }),
            });

            if (!response.ok) {
                const errorResponse = await response.json();
                setAlertStatus("error");
                setAlertMessage(errorResponse.message || "Failed to process subscription. Please try again.");
                return { status: "error", message: "Failed to process subscription. Please try again." };
            }
        } catch (error) {
            console.error("Error:", error);
            setAlertStatus("error");
            setAlertMessage("An unexpected error occurred. Please try again later.");
            return { status: "error", message: "An unexpected error occurred. Please try again later." };
        }
    };

    // Réinitialiser l'alerte après 5 secondes, seulement si l'alerte a été affichée
    useEffect(() => {
        if (isSubmitted) {
            const timeout = setTimeout(() => {
                setAlertStatus(null);
                setAlertMessage("");
                setIsSubmitted(false); // Réinitialiser après la disparition de l'alerte
            }, 5000);
            return () => clearTimeout(timeout); // Nettoyer le timeout à chaque re-rendu
        }
    }, [isSubmitted]);

    return (
        <div>
            <Newsletter
                status={alertStatus}
                message={alertMessage}
                onValidated={handleSubmit}
            />
            {alertStatus && !isSubmitted && ( // Vérifie si le formulaire a été soumis avant d'afficher l'alerte
                <div
                    className={`alert ${
                        alertStatus === "success" ? "alert-success" : "alert-danger"
                    }`}
                >
                    {alertMessage}
                </div>
            )}
        </div>
    );
};
